import { render, staticRenderFns } from "./warning-modal.vue?vue&type=template&id=03afc5a4&scoped=true&"
import script from "./warning-modal.vue?vue&type=script&lang=js&"
export * from "./warning-modal.vue?vue&type=script&lang=js&"
import style0 from "./warning-modal.vue?vue&type=style&index=0&id=03afc5a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03afc5a4",
  null
  
)

export default component.exports